import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"report-list"}},[_c('app-city-header',{attrs:{"payload":_vm.payload}}),_c(VRow,[_c(VCol,[_vm._v("Relatórios")]),_c(VCol,{staticClass:"text-right"},[(
          _vm.isFullAdmin || (_vm.groupsConfig.novoRelatorio && _vm.config.novoRelatorio)
        )?_c(VBtn,{staticClass:"ml-3",attrs:{"outlined":"","color":"primary","to":'/cidade/' + _vm.payload.municipioId + '/relatorio/inserir'}},[_vm._v("\n        Novo Relatório\n      ")]):_vm._e()],1)],1),_c(VRow,[_c(VCol,[_c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.payload.relatorios,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:{
              evidenciada:
                props.item.statusRelatorioId === 2 ||
                props.item.statusRelatorioId === 4,
              evidenciar: props.item.statusRelatorioId === 3,
              rejeitada:
                props.item.statusRelatorioId === 1 ||
                props.item.statusRelatorioId === 0
            }},[_c('td',[_c('a',{attrs:{"href":'./#/cidade/' +
                    props.item.municipioId +
                    '/relatorio/obter/' +
                    props.item.relatorioId}},[_vm._v(_vm._s(props.item.titulo))])]),_c('td',[_vm._v(_vm._s(props.item.usuario.nome))]),_c('td',[_vm._v("\n              "+_vm._s(_vm._f("moment")(props.item.criacao,"DD/MM/YYYY"))+"\n            ")])])]}}])},[_c('template',{slot:"no-data"},[_c('span',[_vm._v("\n            Nenhum relatório retornado\n          ")])])],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }